var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("処理が完了しました。")]),_c('v-row',{attrs:{"no-gutters":""}},[_c('AppButton',{staticClass:"primary ml-2",on:{"click":_vm.reset}},[_vm._v(" 終了 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }